import { Role } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetRolesQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/roles`
	return useQuery<void, RolesOutput>(url)
}
interface RolesOutput {
	roles: Role[]
}
